import React, { useCallback, FC } from 'react';

import { cn, Checkbox, FactorinCheckClass } from 'Modules/ui';

import { cellStyles } from '../Cells';
import { CheckboxHeaderProps, SelectAllProps } from './types';
import styles from './index.module.scss';


export * as CheckboxHeaderTypes from './types';

const checkModel = new FactorinCheckClass<number>();

const SelectAll = React.memo<SelectAllProps>(({
    disabled,
    disableCheckAll,
    height,
    width,
    top,
    itemCount,
    checkedRows,
    onCheckedChanged,
    className,
    checkbox: CustomCheckbox = Checkbox,
}) => {
    const selectAllClick = useCallback(
        () => onCheckedChanged(checkModel.updateAll(itemCount, checkedRows)),
        [checkedRows, itemCount, onCheckedChanged],
    );

    return (
        <div
            className={cn(styles.container, className)}
            style={{ top, height, width }}
        >
            <div className={cellStyles.cell} style={{ height: height - 1, width }}>
                {!disableCheckAll && (
                    <CustomCheckbox
                        disabled={disabled || itemCount === 0}
                        className={styles.checkbox}
                        markClassName={styles.checkboxMark}
                        checked={checkModel.getAll(itemCount, checkedRows)}
                        onChange={selectAllClick}
                    />
                )}
            </div>
        </div>
    );
});

export const CheckboxHeader: FC<CheckboxHeaderProps> = React.memo(({
    width,
    height,
    className,
    withFilters,
    filterHeader: FilterHeader = 'div',
    ...props
}) => (
    <>
        {withFilters && (
            <div
                className={className}
                style={{ height, width }}
            >
                <FilterHeader
                    className={cellStyles.cell}
                    style={{ height, width }}
                />
            </div>
        )}
        <SelectAll
            top={withFilters ? height : 0}
            height={height}
            width={width}
            className={className}
            {...props}
        />
    </>
));
